<!-- 用户管理 -->
<template>
  <div class="diseaseList">
    <!-- 封装selectForm筛选 -->
    <el-form :inline="true">
      <!-- <el-button type="primary" size="small" @click="handleAdd" style="margin: 0 20px 0 0">录入</el-button> -->
      <!-- <el-form-item label="评论内容: " style="margin: 0 20px 0 0" size="small">
        <el-input v-model="listQuery.message" placeholder="请输入" clearable></el-input>
      </el-form-item>-->
      <el-form-item label="视频ID: " style="margin: 0 20px 0 0" size="small">
        <el-input v-model="listQuery.video_id" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="点赞人openid: " style="margin: 0 20px 0 0" size="small">
        <el-input v-model="listQuery.openid" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-button type="primary" @click="search" size="small" style="margin: 0 0px 10 0">搜索</el-button>
      <!-- <el-button
        class="addBtn"
        type="primary"
        size="small"
        style="margin-right: 20px"
        :loading="downloadLoading"
        icon="el-icon-document"
        @click="handleDownload"
      >
        导出 Excel（数量/ {{ tableData.length
        }}条）
      </el-button>-->
    </el-form>

    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="phone" slot-scope="{ row }">
          <!-- <el-image
            style="width: 60px; max-height: 60px"
            :src="row.imgUrl"
            :preview-src-list="[row.imgUrl]"
          ></el-image>-->
          {{row.phone?row.phone:'暂无'}}
        </template>

        <template slot="message" slot-scope="{ row }">
          <!-- <el-image
            style="width: 60px; max-height: 60px"
            :src="row.imgUrl"
            :preview-src-list="[row.imgUrl]"
          ></el-image>-->
          {{row.message?'档案已保存':'暂无数据'}}
        </template>

        <template slot="answerNumber" slot-scope="{ row }">{{row.answerNumber?row.answerNumber:'-'}}</template>

        <!-- <template slot="messgae" slot-scope="{ row }">{{row.message ? row.message : '暂无数据'}}</template> -->

        <template slot="source" slot-scope="{ row }">
          <el-tag
            type="success"
            effect="dark"
            size="mini"
            v-if="row.source == '手动录入'"
          >{{row.source}}</el-tag>
          <el-tag type="danger" effect="dark" size="mini" v-else>{{row.source}}</el-tag>
        </template>
        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button
              size="mini"
              type="text"
              style="color: rgb(255, 0, 0)"
              @click="handleDelete(row)"
            >删除</el-button>
          </div>
        </template>
      </ElTable>
    </div>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import { mapState } from "vuex";
import {
  selectLoveList as selectApi,
  deleteLove as deleteApi
} from "@/services/video/videoConfig.js";
export default {
  components: {
    ElTable
  },
  created() {
    this.getListData();
  },
  data() {
    return {
      downloadLoading: false,
      fileList: [],
      loading: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        video_id: "",
        openid: "",
      },
      stateList: [
        { id: 0, name: "显示" },
        { id: 1, name: "隐藏" }
      ],
      /* 表格数据 */
      tableData: [],
      storeList: [],
      /* 弹窗 */
      dialogName: "",
      dialogVisible: false,
      dialogForm: {},

      dialogVisible_read: false,
      dialogForm_read: {},

      statusList: [
        { id: 0, name: "显示" },
        { id: 1, name: "隐藏" }
      ],
      roleVisible: false,
      navData: [],
      checkedData: [],
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  computed: {
    listHeader,
    ...mapState(["supUser"])
  },

  watch: {},
  methods: {
    async getListData(listQuery) {
      this.loading = true;
      const { data, code, count } = await selectApi(
        listQuery || this.listQuery
      );
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 200);
      }
    },
    /* 搜索按钮 */
    async search() {
      this.getListData();
    },
    /* 分页 */
    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },

    /* 新增 */
    handleAdd() {
      this.dialogVisible = true;
      this.dialogName = "创建检测数据";
      this.dialogForm = {
        message: []
      };
    },

    /* 修改 */
    handleEdit(row) {
      this.dialogVisible = true;
      this.dialogName = "编辑检测数据";
      this.dialogForm = JSON.parse(JSON.stringify(row));
      try {
        this.dialogForm.message = row.message ? JSON.parse(row.message) : [];
      } catch (error) {
        this.dialogForm.message = [];
      }
    },

    /* 查看 */
    handleRead(row) {
      this.dialogVisible_read = true;
      this.dialogForm_read = JSON.parse(JSON.stringify(row));
      try {
        this.dialogForm_read.message = row.message
          ? JSON.parse(row.message)
          : [];
      } catch (error) {
        this.dialogForm_read.message = [];
      }
    },

    handleSuccess(e) {
      console.log("handleSuccess", e);
      this.dialogForm.imgUrl = e.data;
      this.fileList = [];
      this.$message.success("上传成功，请继续操作");
    },

    /* 删除 */
    handleDelete(row) {
      console.log(row.id);
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          console.log(row.id);
          deleteApi({ id: row.id }).then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getListData();
          });
        })
        .catch(() => {});
    },

    /* 导出数据 */
    handleDownload() {
      this.downloadLoading = true;
      import("@/vendor/Export2Excel").then(excel => {
        const tHeader = [
          "ID",
          "检测标题",
          "用户小程序openid",
          "用户手机号",
          "检测数据",
          "创建时间"
        ];
        const filterVal = [
          "id",
          "title",
          "openid",
          "phone",
          "message",
          "createTime"
        ];
        const list = this.tableData.map(item => {
          return {
            ...item
          };
        });
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "患者检测数据下载",
          autoWidth: true, //Optional
          bookType: "xlsx" //Optional
        });
        this.downloadLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j];
        })
      );
    },

    handleAddItem() {
      console.log("this.dialogForm.message", this.dialogForm.message);
      this.dialogForm.message.push({
        keyName: "",
        key: "",
        value: ""
      });
    },

    handleDeleteItem(index) {
      this.dialogForm.message.splice(index, 1);
    }
  }
};
</script>

<style scoped lang="less">
.diseaseList {
  padding: 20px;
  width: 100%;
}

.selectForm {
  background: #fff;
  // max-width: 1405px;
  padding: 10px 0;
  margin: 10px auto;
}

.tableList {
  border-radius: 6px;
  background: #fff;
  // max-width: 1405px;
  margin: 10px auto;
}

.operation {
  a {
    margin-right: 10px;
  }
}

.dialogForm_read {
  border: 1px dotted #000000;
}
.dialogForm_read_item {
  display: flex;
  margin: 20px auto;
  width: 95%;
  background: #f2f2f2;
  padding: 10px 0;
}
.dialogForm_read_item > span:first-child {
  font-weight: 550;
}
</style>
